import { StyledField, StyledGrid, StyledLabel } from '../ui';
import { FormFormattedField, FormInput } from 'components';
import { normalizeFormattedField } from 'utils';

export const CostField = () => {
  return (
    <StyledGrid item xs={12}>
      <StyledLabel>Cost</StyledLabel>
      <StyledField
        name="cost"
        component={FormFormattedField}
        placeholder=""
        // @ts-ignore
        thousandSeparator
        allowNegative={false}
        fixedDecimalScale
        prefix="$"
        customInput={FormInput}
        parse={normalizeFormattedField}
        disableUnderline
      />
    </StyledGrid>
  );
};
